import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import TestsmsIcon from "@mui/icons-material/Textsms";
import { grey } from "designSystem/styles/color";
import { Box, Button, FlexRowCenter, OverflowText, Placeholder } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import React from "react";

interface Props {
	nodeType: string;
	isNodeReadOnly: boolean;
	onConnectToSlack?: () => void;
}

const ConnectToSlackFirstTime: React.FunctionComponent<Props> = ({ nodeType, isNodeReadOnly, onConnectToSlack }) => {
	const locale = useLocale();
	const resParams = [locale.type(nodeType)];
	return (
		<FlexRowCenter
			flexGrow={1}
			justifyContent="center"
			px={3}
		>
			<Placeholder
				subtitleMargin={6}
				subtitleProps={{ res: isNodeReadOnly ? "SlackNoChannelsForReadOnlyUserPlaceholderText" : "ConnectToSlackPlaceholderText", resParams }}
				titleProps={{ res: isNodeReadOnly ? "NoChannelsForReadOnlyUserPlaceholderTitle" : "ConnectToSlackPlaceholderTitle", resParams }}
			>
				{{
					actions:
						isNodeReadOnly ? null : (
							<Button
								design="primary"
								fullWidth
								hideOverflow
								onClick={onConnectToSlack}
							>
								<OverflowText res="ConnectToSlackButton" resParams={resParams} />
							</Button>
						)
					,
					image:
						<Box>
							<Box color={grey[100]} height={36}>
								<ChatBubbleIcon style={{ fontSize: 36 }} />
							</Box>
							<Box
								color={grey[300]}
								height={36}
								ml={9}
							>
								<TestsmsIcon style={{ fontSize: 36, transform: "rotateY(180deg)" }} />
							</Box>
						</Box>
					,
				}}
			</Placeholder>
		</FlexRowCenter>
	);
};

export default ConnectToSlackFirstTime;